// extracted by mini-css-extract-plugin
export default {"component":"NFTs_component__gyJw5","container":"NFTs_container__p51VB","volume":"NFTs_volume__bRDZD"};